const o = {
  dark: "dark",
  light: "light"
};
export {
  o as ColorThemes
};
